import React, { useState, useContext, Fragment } from 'react';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import UserLink from '../../../../../components/User/UserLink';
import DriverLink from '../../../../../components/User/DriverLink';
import CustomerLink from '../../../../../components/User/CustomerLink';
import moment from 'moment-jalaali';
import Pagination from '../../../../../components/OtherElements/Pagination';
import { store } from './reducer';
import { LinearProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  logBox: {
    marginTop: theme.spacing(1),
  },
}));

const OrderLogs = () => {
  const classes = useStyles();
  const {
    state: { logs },
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(store);
  const [page, setPage] = useState(1);
  const handlePageChange = (page) => {
    setPage(page);
  };
  const _logs = logs?.filter(
    (obj) =>
      obj.log.type !== 'order_add_commission_deposit' &&
      obj.log.type !== 'user_add_commission_deposit'
  );

  if (!_logs) return <LinearProgress />;
  return logs?.length ? (
    <React.Fragment>
      {_logs
        .slice((page - 1) * itemsCountPerPage, page * itemsCountPerPage)

        .map((obj) => (
          <Alert severity="info" className={classes.logBox} key={obj._id}>
            {obj.log.text}
            <br />
            {`ایجادکننده:`}
            {<UserLink user={obj.creator} />}
            {` | `}
            {obj?.log?.customer_id ? (
              <Fragment>
                کاربر:
                <CustomerLink user={obj.log.customer_id} avatar={false} />
                {' | '}
              </Fragment>
            ) : null}
            {obj?.log?.driver_id ? (
              <Fragment>
                راننده:
                <DriverLink driverId={obj.log.driver_id} />
              </Fragment>
            ) : null}
            {`مورخ: `}
            {moment(obj.createdAt).format('jYY/jMM/jDD ساعت: hh:mm')}
          </Alert>
        ))}
      <Pagination
        activePage={page}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={logs.length}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
      />
    </React.Fragment>
  ) : (
    <React.Fragment>تاکنون لاگی ثبت نشده است.</React.Fragment>
  );
};

export default OrderLogs;
